module.exports = __webpack_public_path__ + "static/media/hero_final_app.1c7308c4.svg";